module.exports = __webpack_public_path__ + "img/arrowFull_left_gray.836083fc.svg";